import { Localization } from '../../../shared/Localization';

import en from './messages_en';

const localization = new Localization('default_unk', en, [en]);

export default localization;
